import { useEffect, useState } from 'react';
import { axiosInstance } from 'utils/axios';

// material-ui
import { Box, Button, Grid, Typography, TextField, Select, MenuItem, Autocomplete, CircularProgress, Checkbox } from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';
import { gridSpacing } from 'app/constant';
import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import useFetchData from 'hooks/useFetchData';
import InsertdriversRecord from './components/InsertDriverRecords';
import StickyHeadTable from './components/StickyHeadTable';
import { warningAlert, successAlert, errorAlert } from 'ui-component/Toasts';

const Drivers = () => {
    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();

    console.log(token);

    const [drivers, setdrivers] = useState([]);
    const [filterName, setfilterName] = useState('');
    const [filterPlateNo, setfilterPlateNo] = useState('');
    const [filterActive, setFilterActive] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);
    const { data: driverCarTypesID } = useFetchData('/CarTypes/All');

    //fetch sales start
    const fetchDriversRecord = async () => {
        let driversRecordURL = `/Drivers/All?`;
        if (filterName !== '') {
            driversRecordURL += `&name=${filterName}`;
        }

        if (filterPlateNo !== '') {
            driversRecordURL += `&plateNo=${filterPlateNo}`;
        }

        if (driverCarTypeID !== '') {
            driversRecordURL += `&carTypeID=${driverCarTypeID}`;
        }

        if (filterActive !== 0) {
            driversRecordURL += `&active=${filterActive}`;
        }
        setLoading(true);
        setFilterBtnDisabled(true);
        try {
            const res = await axiosInstance.get(driversRecordURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setdrivers(res.data);
                console.log(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFilterBtnDisabled(false);
            setLoading(false);
        }
    };

    const [driverCarTypeID, setdriverCarTypeID] = useState([]); // Initialize as empty object instead of array
    const fetchCarTypesID = async () => {
        try {
            const res = await axiosInstance.get('/CarTypes/All', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setdriverCarTypeID(res.data);
                console.log('This is from the drivers cars type ID', driverCarTypeID);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    
    const [driverCurrentStatus, setDriverCurrentStatus] = useState([]);
    const fetchDriverCurrentStatus = async () => {
        try {
            const res = await axiosInstance.get('/DriverCurrentStatus/All', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setDriverCurrentStatus(res.data);
                console.log('This is from the drivers cars type ID', driverCurrentStatus);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        setLoading(true);

        const fetchFunctions = [fetchCarTypesID(), fetchDriverCurrentStatus()];

        Promise.all(fetchFunctions)
            .then((values) => {
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setLoading(false);
            });
    }, []);

    return (
        <Grid container item xs={12} padding="20px">
            <InsertdriversRecord
                driverCarTypeID={driverCarTypeID}
                driverCurrentStatus={driverCurrentStatus}
            />
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Name :
                        </Typography>
                        <input
                            type="text"
                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                            value={filterName}
                            onChange={(e) => setfilterName(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Plate No :
                        </Typography>
                        <input
                            type="text"
                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                            value={filterPlateNo}
                            onChange={(e) => setfilterPlateNo(e.target.value)}
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Car Type ID :
                        </Typography>

                        <Select
                            displayEmpty
                            value={driverCarTypeID}
                            onChange={(e) => setdriverCarTypeID(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Status
                            </MenuItem>
                            {driverCarTypeID.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Active :
                        </Typography>
                        <Checkbox
                            checked={filterActive}
                            onChange={(e) => setFilterActive(e.target.checked)} // Use checked value directly
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={12} lg={12}>
                    <Button
                        variant="contained"
                        sx={{
                            float: 'right',
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '30px'
                        }}
                        onClick={() => fetchDriversRecord()}
                        disabled={filterBtnDisabled}
                    >
                        Filter
                    </Button>
                </Grid>
                <Box sx={{ width: '100%', minHeight: '200px' }}>
                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <StickyHeadTable
                            drivers={drivers}
                            fetchDriversRecord={fetchDriversRecord}
                            driverCarTypeID={driverCarTypeID}
                            driverCurrentStatus={driverCurrentStatus}
                        />
                        
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default Drivers;
